export const TABS_HEADING_SPACING = "pt-4";
export const TABS_CONTENT_SPACING = "pt-2";

export const IMAGE_URL = "https://content.breakfreeholidays.co.uk/images";

export const DEFAULT_FILTER_VALUE = "All";
export const DEFAULT_CATEGORY = "All";

export const IS_PRODUCTION_ENV = process.env.REACT_APP_ENV === "production";
export const IS_UAT_ENV = process.env.REACT_APP_ENV === "uat";
export const IS_DEV_ENV = process.env.REACT_APP_ENV === "development";

// Block [Cafe, Disco, Jacuzzi, Snooker/Pool, Supermarket]
export const HIDDEN_FACILITIES = [3, 7, 11, 18, 20];

export const BREAKPOINTS = {
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
};

export const MONTH_MAP = {
  January: 0,
  February: 1,
  March: 2,
  April: 3,
  May: 4,
  June: 5,
  July: 6,
  August: 7,
  September: 8,
  October: 9,
  November: 10,
  December: 11,
};
